module.exports = __webpack_public_path__ + "static/Mrs Pauline Maslin-18c35aebf3dfacc9d554efc35d455484.png";